import styled from 'styled-components';

export const ImageContainer = styled.div`
  align-items: center;
  display: flex;
`;
